// Mirror of responseScore and roundScore in src/services/evaluationScoringService.js; both are specced on evaluationScoreCases.json.
import { EvaluationQuestionType, EvaluationQuestionTypeValue } from './evaluationContract';

export type ScoreAnswer = { key: string; score?: number | null; skipped?: boolean };
export type ScoreQuestion = { key: string; type: EvaluationQuestionTypeValue };
export type ResponseScore = { score: number | null; scoredCount: number; skippedCount: number };

// The epsilon makes x,x5 round up even when floating point stores it just below the half.
export const roundScore = (x: number): number => Math.round(x * 10 + 1e-9) / 10;

const isScore = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value);

export const responseScore = (
  answers: ScoreAnswer[],
  questions: ScoreQuestion[],
): ResponseScore => {
  const ratingKeys = new Set(
    questions.filter(q => q.type === EvaluationQuestionType.Rating).map(q => q.key),
  );
  const ratingAnswers = answers.filter(answer => ratingKeys.has(answer.key));
  const scores = ratingAnswers
    .filter(answer => !answer.skipped)
    .map(answer => answer.score)
    .filter(isScore);

  return {
    score: scores.length ? scores.reduce((sum, v) => sum + v, 0) / scores.length : null,
    scoredCount: scores.length,
    skippedCount: ratingAnswers.filter(answer => answer.skipped).length,
  };
};
